export default "__VITE_ASSET__BsF_dQ3D__"